import Cookies from "universal-cookie";

const storage = {
  get: (key: string) => window.localStorage.getItem(key),
  set: (key: string, val: string) => window.localStorage.setItem(key, val),
  remove: (key: string) => window.localStorage.removeItem(key),
};

const session_storage = {
  get: (key: string) => window.localStorage.getItem(key),
  set: (key: string, val: string) => window.localStorage.setItem(key, val),
  remove: (key: string) => window.localStorage.removeItem(key),
};

const setToken = (token: string) => {
  storage.set("@Token", token);
};

const getToken = () => storage.get("@Token");

const clearToken = () => {
  storage.remove("@Token");
  clearAuthAccess();
  clearAuthRefresh();
  clearAuthSession();
};

const setUserRole = (userRole: string) => {
  storage.set("@Role", userRole);
};

const getUserRole = () => storage.get("@Role");

const clearUserRole = () => {
  storage.remove("@Role");
};

const token = async () => storage.get("@Token");

const setAuthAccess = (token: string) => {
  storage.set("@authAccess", token);
};

const getAuthAccess = () => storage.get("@authAccess");

const clearAuthAccess = () => {
  storage.remove("@authAccess");
};

const setAuthRefresh = (token: string) => {
  storage.set("@authRefresh", token);
};

const getAuthRefresh = () => storage.get("@authRefresh");

const clearAuthRefresh = () => {
  storage.remove("@authRefresh");
};

const clearAuthSession = () => {
  session_storage.remove("auth-storage");
};

// set cookies
const setCookie = (key: string, val: string) => {
  const cookies = new Cookies();

  return cookies.set(key, val, { maxAge: 172800 }); // set cookie value for two days
};

// get cookies
const getCookie = (key: string) => {
  const cookies = new Cookies();

  return cookies.get(key);
};

export default {
  // ...request,
  storage,
  token,
  clearToken,
  getToken,
  setToken,
  getCookie,
  setCookie,
  setUserRole,
  getUserRole,
  clearUserRole,
  setAuthAccess,
  getAuthAccess,
  clearAuthAccess,
  clearAuthSession,
  setAuthRefresh,
  getAuthRefresh,
  clearAuthRefresh,
};
